const UPDATE_FILTERS = 'src/filters/UPDATE_FILTERS';
const CLEAR_FILTERS = 'src/filters/CLEAR_FILTERS';
const UPDATE_IS_CLEARING_FILTERS_BOOL = 'src/app/UPDATE_IS_CLEARING_FILTERS_BOOL';

export default {
  CLEAR_FILTERS,
  UPDATE_FILTERS,
  UPDATE_IS_CLEARING_FILTERS_BOOL
};
